// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__YwCgc","row":"ProcedureTreatmentSummary_row__2fuVV"};